import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0fbfc7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Back to Bookings ")
const _hoisted_3 = {
  key: 3,
  class: "booking-card"
}
const _hoisted_4 = { class: "booking-header" }
const _hoisted_5 = { class: "header-actions" }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "edit-section" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Stay Details", -1))
const _hoisted_9 = { class: "edit-grid" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Arrival", -1))
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Departure", -1))
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Adults", -1))
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Children", -1))
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Animals", -1))
const _hoisted_20 = { class: "edit-section" }
const _hoisted_21 = { class: "section-heading" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Site Assignment", -1))
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "edit-grid site-assignment-grid" }
const _hoisted_25 = { class: "form-group site-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Site", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Do not change", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 0,
  class: "field-note"
}
const _hoisted_30 = { class: "edit-section" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Equipment", -1))
const _hoisted_32 = { class: "edit-grid" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Equipment Type ID", -1))
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Equipment Length", -1))
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Equipment Width", -1))
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Equipment Height", -1))
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Unit", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Do not change", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ft" }, "Feet", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "m" }, "Meters", -1))
const _hoisted_46 = [
  _hoisted_43,
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Slideouts", -1))
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-f0fbfc7c>Do not change</option><option value=\"none\" data-v-f0fbfc7c>None</option><option value=\"passenger_side\" data-v-f0fbfc7c>Passenger Side</option><option value=\"driver_side\" data-v-f0fbfc7c>Driver Side</option><option value=\"both_sides\" data-v-f0fbfc7c>Both Sides</option>", 5)
const _hoisted_54 = [
  _hoisted_49
]
const _hoisted_55 = { class: "edit-section" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Status", -1))
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-f0fbfc7c>Do not change</option><option value=\"Confirmed\" data-v-f0fbfc7c>Confirmed</option><option value=\"Unconfirmed\" data-v-f0fbfc7c>Unconfirmed</option><option value=\"Quote\" data-v-f0fbfc7c>Quote</option><option value=\"Arrived\" data-v-f0fbfc7c>Arrived</option><option value=\"Departed\" data-v-f0fbfc7c>Departed</option><option value=\"Cancelled\" data-v-f0fbfc7c>Cancelled</option><option value=\"No-Show\" data-v-f0fbfc7c>No-Show</option><option value=\"Waitlist\" data-v-f0fbfc7c>Waitlist</option>", 9)
const _hoisted_67 = [
  _hoisted_58
]
const _hoisted_68 = { class: "edit-actions" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = {
  key: 1,
  class: "detail-grid"
}
const _hoisted_71 = { class: "detail-item" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Guest", -1))
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { class: "detail-item" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Arrival", -1))
const _hoisted_76 = { class: "detail-item" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Departure", -1))
const _hoisted_78 = { class: "detail-item" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Status", -1))
const _hoisted_80 = { class: "detail-item" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Total", -1))
const _hoisted_82 = { class: "detail-item" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Nightly Rate", -1))
const _hoisted_84 = { class: "detail-item" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Balance", -1))
const _hoisted_86 = { class: "detail-item" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Adults", -1))
const _hoisted_88 = { class: "detail-item" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Children", -1))
const _hoisted_90 = { class: "detail-item" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Animals", -1))
const _hoisted_92 = { class: "detail-item" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Site", -1))
const _hoisted_94 = { class: "detail-item" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Category", -1))
const _hoisted_96 = { class: "detail-item" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Equipment", -1))
const _hoisted_98 = {
  key: 2,
  class: "section"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Nightly Rates", -1))
const _hoisted_100 = { class: "balance-table" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Date"),
  /*#__PURE__*/_createElementVNode("th", null, "Rate"),
  /*#__PURE__*/_createElementVNode("th", null, "Plan")
], -1))
const _hoisted_102 = {
  key: 3,
  class: "section"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Payments", -1))
const _hoisted_104 = {
  key: 0,
  class: "balance-table"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Date"),
  /*#__PURE__*/_createElementVNode("th", null, "Description"),
  /*#__PURE__*/_createElementVNode("th", null, "Method"),
  /*#__PURE__*/_createElementVNode("th", null, "Amount")
], -1))
const _hoisted_106 = {
  key: 0,
  class: "voided-tag"
}
const _hoisted_107 = {
  key: 1,
  class: "muted"
}
const _hoisted_108 = { class: "balance-note" }
const _hoisted_109 = /*#__PURE__*/_createTextVNode(" Total paid: ")
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" · Outstanding balance: ")
const _hoisted_111 = {
  key: 4,
  class: "section"
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Account Breakdown", -1))
const _hoisted_113 = { class: "balance-table" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Account"),
  /*#__PURE__*/_createElementVNode("th", null, "Balance")
], -1))
const _hoisted_115 = {
  key: 5,
  class: "section notes-section"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Notes", -1))
const _hoisted_117 = ["onSubmit"]
const _hoisted_118 = { class: "edit-actions" }
const _hoisted_119 = ["disabled"]
const _hoisted_120 = {
  key: 0,
  class: "notes-list"
}
const _hoisted_121 = { class: "note-meta" }
const _hoisted_122 = {
  key: 1,
  class: "muted"
}

import { computed, onMounted, ref } from "vue";
import api from "@virgodev/bazaar/functions/api";
import BaseSpinner from "@/components/BaseSpinner.vue";
import NewbookPaymentLinkModal from "@/components/NewbookPaymentLinkModal.vue";

interface NewbookGuestRow {
  guest_id?: string | number;
  id?: string | number;
  guest_name?: string;
  name?: string;
  guest_firstname?: string;
  guest_lastname?: string;
  firstname?: string;
  lastname?: string;
  primary_client?: string | number | boolean;
}

interface BookingDetailRow {
  booking_id: string | number;
  guest_id?: string | number;
  guest?: NewbookGuestRow;
  guests?: NewbookGuestRow[];
  guest_name?: string;
  guest_firstname?: string;
  guest_lastname?: string;
  booking_arrival?: string;
  booking_departure?: string;
  booking_status?: string;
  booking_total?: string | number;
  total?: string | number;
  tariff_total?: string | number;
  tariff_name?: string;
  tariffs_quoted?: TariffQuotedRow[];
  booking_length?: string | number;
  calculated_total?: string | number;
  account_id?: string | number;
  account_balance?: string | number;
  account_breakdown?: AccountBreakdownRow[];
  booking_adults?: string | number;
  booking_children?: string | number;
  booking_animals?: string | number;
  site_id?: string | number;
  booking_site_id?: string | number;
  booking_site_name?: string;
  site_name?: string;
  category_id?: string | number;
  booking_category_id?: string | number;
  category_name?: string;
  booking_category_name?: string;
  equipment_type_id?: string | number;
  booking_equipment_type_id?: string | number;
  equipment_type?: string;
  equipment_type_name?: string;
  equipment_length?: string | number;
  booking_equipment_length?: string | number;
  equipment_width?: string | number;
  booking_equipment_width?: string | number;
  equipment_height?: string | number;
  booking_equipment_height?: string | number;
  equipment_measurement_unit?: string;
  booking_equipment_measurement_unit?: string;
  slideouts?: string;
  booking_slideouts?: string;
}

interface AccountBreakdownRow {
  name?: string;
  gl_category_id?: string | number;
  balance?: string | number;
}

interface TariffQuotedRow {
  tariff_quoted_id?: string | number;
  stay_date?: string;
  label?: string;
  type_id?: string | number;
  tariff_applied_id?: string | number;
  charge_amount?: string | number;
  calculated_amount?: string | number;
  original_amount?: string | number;
}

interface PaymentRow {
  id?: string | number;
  description?: string;
  amount?: string | number;
  type?: string;
  transaction_method?: string;
  generated_when?: string;
  voided_when?: string | null;
}

interface NoteRow {
  id?: string | number;
  note_id?: string | number;
  title?: string;
  note_title?: string;
  content?: string;
  note_content?: string;
  created_when?: string;
  created_at?: string;
  generated_when?: string;
  inserted_when?: string;
  user?: string;
  username?: string;
  author?: string;
}

interface AvailabilitySiteRow {
  site_id: string | number;
  site_name?: string;
  name?: string;
  category_id?: string | number;
  category_name?: string;
  category?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    bookingId: null,
    facilityId: null,
    facilityName: null
  },
  setup(__props: any) {

const props = __props as {
  bookingId: string;
  facilityId: string;
  facilityName?: string;
}



const status = ref("loading");
const booking = ref<BookingDetailRow | null>(null);
const payments = ref<PaymentRow[]>([]);
const errorMessage = ref("");
const successMessage = ref("");
const editingBooking = ref(false);
const savingBooking = ref(false);
const loadingSites = ref(false);
const siteLoadMessage = ref("");
const availableSites = ref<AvailabilitySiteRow[]>([]);
const showPaymentLink = ref(false);
const bookingNote = ref("");
const savingBookingNote = ref(false);
const localBookingNotes = ref<NoteRow[]>([]);
const editForm = ref({
  period_from: "",
  period_to: "",
  adults: 1,
  children: 0,
  animals: 0,
  site_id: null as number | null,
  category_id: null as number | null,
  equipment_type_id: null as number | null,
  equipment_length: null as number | null,
  equipment_width: null as number | null,
  equipment_height: null as number | null,
  equipment_measurement_unit: "",
  slideouts: "",
  status: "",
});

const paymentsTotal = computed(() =>
  payments.value.reduce<number>((total, payment) => {
    if (payment.voided_when) return total;
    const amount = numericAmount(payment.amount ?? 0);
    return Number.isFinite(amount) ? total + amount : total;
  }, 0)
);

const tariffsQuoted = computed<TariffQuotedRow[]>(() => {
  const raw = booking.value?.tariffs_quoted;
  return Array.isArray(raw) ? raw : [];
});

const bookingNotes = computed(() => [
  ...localBookingNotes.value,
  ...extractNotes(booking.value),
]);

const nightlyRate = computed(() => {
  const tariffs = tariffsQuoted.value;
  if (tariffs.length) {
    const amounts = tariffs
      .map((row) =>
        numericAmount(
          row.charge_amount ?? row.calculated_amount ?? row.original_amount ?? 0
        )
      )
      .filter((value) => Number.isFinite(value));
    if (amounts.length) {
      const min = Math.min(...amounts);
      const max = Math.max(...amounts);
      return min === max ? min : null;
    }
  }
  const tariffTotal = numericAmount(booking.value?.tariff_total ?? 0);
  const nights = numericAmount(booking.value?.booking_length ?? 0);
  if (
    Number.isFinite(tariffTotal) &&
    Number.isFinite(nights) &&
    tariffTotal > 0 &&
    nights > 0
  ) {
    return tariffTotal / nights;
  }
  return null;
});

const availableSitesForSelect = computed(() => {
  const currentId = siteId(booking.value || ({} as BookingDetailRow));
  const currentSite = currentId
    ? {
        site_id: currentId,
        site_name:
          booking.value?.site_name ||
          booking.value?.booking_site_name ||
          "Current site",
        category_id: categoryId(booking.value || ({} as BookingDetailRow)),
        category_name:
          booking.value?.category_name || booking.value?.booking_category_name,
      }
    : null;
  const sites = [...availableSites.value];
  if (
    currentSite &&
    !sites.some((site) => String(site.site_id) === String(currentSite.site_id))
  ) {
    sites.unshift(currentSite);
  }
  return sites;
});

onMounted(loadBooking);

async function loadBooking() {
  status.value = "loading";
  try {
    const qs = new URLSearchParams({
      facilityId: props.facilityId,
      booking_id: props.bookingId,
      data_limit: "1",
      account_breakdown: "true",
    }).toString();
    const response = await api({
      url: `nb/bookings/?${qs}`,
      method: "GET",
    });

    if (response.ok) {
      const rows = Array.isArray(response.body.data) ? response.body.data : [];
      booking.value = (rows[0] ||
        response.body.data ||
        null) as BookingDetailRow;
      await loadPayments();
    } else {
      const body = "body" in response ? response.body : undefined;
      errorMessage.value = body?.error || "Failed to load booking.";
    }
  } catch {
    errorMessage.value = "An error occurred while loading booking details.";
  }
  status.value = "loaded";
}

async function loadPayments() {
  payments.value = [];
  try {
    const qs = new URLSearchParams({
      facilityId: props.facilityId,
      booking_id: props.bookingId,
    }).toString();
    const response = await api({
      url: `nb/payments/?${qs}`,
      method: "GET",
    });
    if (response.ok) {
      const rows = Array.isArray(response.body.data) ? response.body.data : [];
      payments.value = rows as PaymentRow[];
    }
  } catch {
    // Payments are non-essential to the rest of the page; ignore failures.
  }
}

function startEdit() {
  if (!booking.value) return;
  editForm.value = {
    period_from: formatDate(booking.value.booking_arrival || ""),
    period_to: formatDate(booking.value.booking_departure || ""),
    adults: Number(booking.value.booking_adults ?? 1),
    children: Number(booking.value.booking_children ?? 0),
    animals: Number(booking.value.booking_animals ?? 0),
    site_id: optionalNumber(siteId(booking.value)),
    category_id: optionalNumber(categoryId(booking.value)),
    equipment_type_id: optionalNumber(equipmentTypeId(booking.value)),
    equipment_length: optionalNumber(equipmentLength(booking.value)),
    equipment_width: optionalNumber(equipmentWidth(booking.value)),
    equipment_height: optionalNumber(equipmentHeight(booking.value)),
    equipment_measurement_unit:
      booking.value.equipment_measurement_unit ||
      booking.value.booking_equipment_measurement_unit ||
      "",
    slideouts: booking.value.slideouts || booking.value.booking_slideouts || "",
    status: "",
  };
  successMessage.value = "";
  editingBooking.value = true;
  loadAvailableSites();
}

async function saveBooking() {
  if (!booking.value) return;
  savingBooking.value = true;
  errorMessage.value = "";
  successMessage.value = "";
  const json: Record<string, string | number> = {
    booking_id: booking.value.booking_id,
    period_from: editForm.value.period_from,
    period_to: editForm.value.period_to,
    adults: editForm.value.adults,
    children: editForm.value.children,
    animals: editForm.value.animals,
  };
  if (editForm.value.status) {
    json.status = editForm.value.status;
  }
  addOptionalNumber(json, "site_id", editForm.value.site_id);
  addOptionalNumber(json, "category_id", editForm.value.category_id);
  addOptionalNumber(
    json,
    "equipment_type_id",
    editForm.value.equipment_type_id
  );
  addOptionalNumber(json, "equipment_length", editForm.value.equipment_length);
  addOptionalNumber(json, "equipment_width", editForm.value.equipment_width);
  addOptionalNumber(json, "equipment_height", editForm.value.equipment_height);
  if (editForm.value.equipment_measurement_unit) {
    json.equipment_measurement_unit = editForm.value.equipment_measurement_unit;
  }
  if (editForm.value.slideouts) {
    json.slideouts = editForm.value.slideouts;
  }

  try {
    const response = await api({
      url: `nb/bookings/?facilityId=${props.facilityId}`,
      method: "PUT",
      json,
    });
    if (response.ok) {
      editingBooking.value = false;
      successMessage.value = "Booking updated successfully.";
      await loadBooking();
    } else {
      const body = "body" in response ? response.body : undefined;
      errorMessage.value = body?.error || "Failed to update booking.";
    }
  } catch {
    errorMessage.value = "An error occurred while updating the booking.";
  }
  savingBooking.value = false;
}

async function saveBookingNote() {
  if (savingBookingNote.value) return;
  const content = bookingNote.value.trim();
  if (!content) return;

  savingBookingNote.value = true;
  errorMessage.value = "";
  successMessage.value = "";
  try {
    const response = await api({
      url: `nb/notes/?facilityId=${props.facilityId}`,
      method: "POST",
      json: {
        for_: "bookings",
        for_id: Number(props.bookingId),
        content,
      },
    });
    if (response.ok) {
      localBookingNotes.value.unshift({
        content,
        created_when: new Date().toISOString(),
      });
      bookingNote.value = "";
      successMessage.value = "Booking note saved successfully.";
      await loadBooking();
      removeSyncedLocalBookingNotes();
    } else {
      const body = "body" in response ? response.body : undefined;
      errorMessage.value = body?.error || "Failed to save booking note.";
    }
  } catch {
    errorMessage.value = "An error occurred while saving the booking note.";
  }
  savingBookingNote.value = false;
}

function removeSyncedLocalBookingNotes() {
  const remoteContents = new Set(
    extractNotes(booking.value).map((note) => noteContent(note))
  );
  localBookingNotes.value = localBookingNotes.value.filter(
    (note) => !remoteContents.has(noteContent(note))
  );
}

async function loadAvailableSites() {
  siteLoadMessage.value = "";
  availableSites.value = [];
  if (!editForm.value.period_from || !editForm.value.period_to) {
    siteLoadMessage.value = "Select arrival and departure dates to load sites.";
    return;
  }
  loadingSites.value = true;
  const json: Record<string, string | number> = {
    period_from: editForm.value.period_from + " 00:00:00",
    period_to: editForm.value.period_to + " 23:59:59",
    adults: editForm.value.adults || 1,
    children: editForm.value.children || 0,
    animals: editForm.value.animals || 0,
  };

  try {
    const response = await api({
      url: `nb/availability/?facilityId=${props.facilityId}`,
      method: "POST",
      json,
    });
    if (response.ok) {
      availableSites.value = Array.isArray(response.body.data)
        ? (response.body.data as AvailabilitySiteRow[])
        : [];
      if (!availableSites.value.length) {
        siteLoadMessage.value =
          "No alternate available sites found for these dates and guest counts.";
      } else {
        siteLoadMessage.value = `Loaded ${availableSites.value.length} available site option(s).`;
      }
    } else {
      const body = "body" in response ? response.body : undefined;
      siteLoadMessage.value = body?.error || "Unable to load available sites.";
    }
  } catch {
    siteLoadMessage.value = "An error occurred while loading available sites.";
  }
  loadingSites.value = false;
}

function primaryGuest(row: BookingDetailRow): NewbookGuestRow | null {
  if (row.guest) return row.guest;
  if (Array.isArray(row.guests) && row.guests.length) {
    return (
      row.guests.find((guest) =>
        ["1", "true", "yes"].includes(
          String(guest.primary_client).toLowerCase()
        )
      ) || row.guests[0]
    );
  }
  if (row.guest_id) return row;
  return null;
}

function primaryGuestId(row: BookingDetailRow) {
  const guest = primaryGuest(row);
  return guest?.guest_id || guest?.id || row.guest_id || "";
}

function primaryGuestName(row: BookingDetailRow) {
  const guest = primaryGuest(row);
  const first = guest?.guest_firstname || guest?.firstname || "";
  const last = guest?.guest_lastname || guest?.lastname || "";
  return (
    guest?.guest_name ||
    guest?.name ||
    [first, last].filter(Boolean).join(" ") ||
    `Guest ${primaryGuestId(row)}`
  );
}

function siteLabelFromOption(site: AvailabilitySiteRow) {
  const name = site.site_name || site.name || `Site ${site.site_id}`;
  const category = site.category_name || site.category;
  return [name, category ? `(${category})` : "", `#${site.site_id}`]
    .filter(Boolean)
    .join(" ");
}

function syncCategoryFromSite() {
  const selected = availableSitesForSelect.value.find(
    (site) => String(site.site_id) === String(editForm.value.site_id)
  );
  if (selected?.category_id) {
    editForm.value.category_id = optionalNumber(selected.category_id);
  }
}

function formatDate(dt?: string | null) {
  if (!dt) return "-";
  return dt.slice(0, 10);
}

function extractNotes(row: unknown) {
  if (!row || typeof row !== "object") return [];
  const record = row as Record<string, unknown>;
  const values = [
    record.notes,
    record.output_messages,
    record.outputMessages,
    record.messages,
    record.note,
  ];
  const notes: NoteRow[] = [];
  for (const value of values) {
    if (Array.isArray(value)) {
      for (const note of value) {
        const normalized = normalizeNote(note);
        if (normalized) notes.push(normalized);
      }
    } else {
      const normalized = normalizeNote(value);
      if (normalized) notes.push(normalized);
    }
  }
  return notes.filter((note, index, all) => {
    const key = `${note.id || note.note_id || ""}:${noteContent(note)}`;
    return (
      all.findIndex((candidate) => {
        const candidateKey = `${
          candidate.id || candidate.note_id || ""
        }:${noteContent(candidate)}`;
        return candidateKey === key;
      }) === index
    );
  });
}

function normalizeNote(value: unknown): NoteRow | null {
  if (!value) return null;
  if (typeof value === "string") {
    return value.trim() ? { content: value } : null;
  }
  if (typeof value !== "object") return null;
  const note = value as NoteRow;
  return noteContent(note).trim() ? note : null;
}

function noteContent(note: NoteRow) {
  return note.content || note.note_content || "";
}

function noteTitle(note: NoteRow) {
  return (
    note.title ||
    note.note_title ||
    note.user ||
    note.username ||
    note.author ||
    "Note"
  );
}

function noteDate(note: NoteRow) {
  return formatDateTime(
    note.created_when ||
      note.created_at ||
      note.generated_when ||
      note.inserted_when ||
      ""
  );
}

function formatDateTime(value?: string | null) {
  if (!value) return "";
  const normalized = value.includes("T") ? value : value.replace(" ", "T");
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("en-US", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
}

function bookingTotal(row: BookingDetailRow) {
  return firstMeaningfulAmount(
    row.booking_total,
    row.total,
    row.tariff_total,
    row.calculated_total
  );
}

function bookingBalance(row: BookingDetailRow) {
  // The booking's outstanding balance is the booking total minus every
  // (non-voided) payment we found via payments_list for this booking's
  // client account. We compute it ourselves rather than relying on
  // account_balance / account_breakdown because Newbook only posts those
  // figures once charges have been "actioned" - until then a brand-new
  // booking would otherwise look fully paid (balance: 0) when it isn't,
  // and a paid booking whose payments live on the guest sub-account
  // would otherwise still show the full total.
  const total = numericAmount(bookingTotal(row) ?? 0);
  if (!Number.isFinite(total)) {
    return bookingTotal(row);
  }
  const balance = total - paymentsTotal.value;
  return Math.abs(balance) < 0.005 ? 0 : balance;
}

function firstMeaningfulAmount(
  ...values: Array<string | number | null | undefined>
) {
  const fallback = values.find(
    (value) => value !== null && value !== undefined && value !== ""
  );
  const nonZero = values.find((value) => {
    if (value === null || value === undefined || value === "") return false;
    const amount = numericAmount(value);
    return Number.isFinite(amount) && amount !== 0;
  });
  return nonZero ?? fallback ?? null;
}

function money(value: string | number | null | undefined) {
  if (value === null || value === undefined || value === "") return "-";
  const amount = numericAmount(value);
  if (!Number.isFinite(amount)) return String(value);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
}

function numericAmount(value: string | number) {
  return Number(String(value).replace(/[^0-9.-]/g, ""));
}

function optionalNumber(value: string | number | null | undefined) {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function addOptionalNumber(
  json: Record<string, string | number>,
  key: string,
  value: number | null
) {
  if (value !== null && Number.isFinite(value)) {
    json[key] = value;
  }
}

function siteId(row: BookingDetailRow) {
  return row.site_id || row.booking_site_id || "";
}

function categoryId(row: BookingDetailRow) {
  return row.category_id || row.booking_category_id || "";
}

function equipmentTypeId(row: BookingDetailRow) {
  return row.equipment_type_id || row.booking_equipment_type_id || "";
}

function equipmentLength(row: BookingDetailRow) {
  return row.equipment_length || row.booking_equipment_length || "";
}

function equipmentWidth(row: BookingDetailRow) {
  return row.equipment_width || row.booking_equipment_width || "";
}

function equipmentHeight(row: BookingDetailRow) {
  return row.equipment_height || row.booking_equipment_height || "";
}

function siteLabel(row: BookingDetailRow) {
  const id = siteId(row);
  return [row.site_name || row.booking_site_name, id ? `#${id}` : ""]
    .filter(Boolean)
    .join(" ");
}

function categoryLabel(row: BookingDetailRow) {
  const id = categoryId(row);
  return [row.category_name || row.booking_category_name, id ? `#${id}` : ""]
    .filter(Boolean)
    .join(" ");
}

/** Newbook often sends label "Unknown Rate" when no tariff plan name exists in their setup. */
function isPlaceholderTariffPlanLabel(text: string): boolean {
  const t = text.trim().toLowerCase();
  if (!t) return true;
  return t === "unknown rate" || t === "unknown" || t === "n/a" || t === "none";
}

function tariffPlanLabel(
  row: TariffQuotedRow,
  bookingRow: BookingDetailRow | null
): string {
  const fromNight = row.label?.trim();
  if (fromNight && !isPlaceholderTariffPlanLabel(fromNight)) return fromNight;
  if (bookingRow) {
    const tn = bookingRow.tariff_name?.trim();
    if (tn && !isPlaceholderTariffPlanLabel(tn)) return tn;
    const cat = categoryLabel(bookingRow);
    if (cat) return cat;
  }
  if (
    row.tariff_applied_id !== undefined &&
    row.tariff_applied_id !== null &&
    row.tariff_applied_id !== ""
  ) {
    return `Tariff ${row.tariff_applied_id}`;
  }
  if (row.type_id !== undefined && row.type_id !== null && row.type_id !== "") {
    return `Rate type ${row.type_id}`;
  }
  return "-";
}

function equipmentLabel(row: BookingDetailRow) {
  const type =
    row.equipment_type || row.equipment_type_name || equipmentTypeId(row);
  const dimensions = [
    equipmentLength(row),
    equipmentWidth(row),
    equipmentHeight(row),
  ]
    .filter(Boolean)
    .join(" x ");
  const unit =
    row.equipment_measurement_unit || row.booking_equipment_measurement_unit;
  return [type ? `Type ${type}` : "", dimensions, unit, row.slideouts]
    .filter(Boolean)
    .join(" ");
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, "Booking #" + _toDisplayString(__props.bookingId), 1),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterLink, {
        class: "btn",
        to: { name: 'nb_bookings', params: { facilityId: __props.facilityId, facilityName: __props.facilityName } }
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["to"]),
      (status.value === 'loading')
        ? (_openBlock(), _createBlock(BaseSpinner, {
            key: 0,
            preset: "large"
          }))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 1,
            variant: "danger",
            dismissible: "",
            onDismissed: _cache[0] || (_cache[0] = ($event: any) => (errorMessage.value = ''))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorMessage.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (successMessage.value)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 2,
            variant: "success"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(successMessage.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (status.value === 'loaded' && booking.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, "Booking #" + _toDisplayString(booking.value.booking_id || __props.bookingId), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "btn btn-sm",
                  type: "button",
                  onClick: startEdit
                }, " Edit Booking "),
                _createElementVNode("button", {
                  class: "btn btn-sm",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showPaymentLink.value = true))
                }, " Payment ")
              ])
            ]),
            (editingBooking.value)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  class: "edit-panel",
                  onSubmit: _withModifiers(saveBooking, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.period_from) = $event)),
                          type: "date"
                        }, null, 512), [
                          [_vModelText, editForm.value.period_from]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editForm.value.period_to) = $event)),
                          type: "date"
                        }, null, 512), [
                          [_vModelText, editForm.value.period_to]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editForm.value.adults) = $event)),
                          type: "number",
                          min: "0"
                        }, null, 512), [
                          [
                            _vModelText,
                            editForm.value.adults,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editForm.value.children) = $event)),
                          type: "number",
                          min: "0"
                        }, null, 512), [
                          [
                            _vModelText,
                            editForm.value.children,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editForm.value.animals) = $event)),
                          type: "number",
                          min: "0"
                        }, null, 512), [
                          [
                            _vModelText,
                            editForm.value.animals,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("button", {
                        class: "btn btn-sm",
                        type: "button",
                        disabled: loadingSites.value,
                        onClick: loadAvailableSites
                      }, _toDisplayString(loadingSites.value ? "Loading..." : "Refresh Sites"), 9, _hoisted_23)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editForm.value.site_id) = $event)),
                          class: "form-select",
                          onChange: syncCategoryFromSite
                        }, [
                          _hoisted_27,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableSitesForSelect), (site) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: String(site.site_id),
                              value: site.site_id
                            }, _toDisplayString(siteLabelFromOption(site)), 9, _hoisted_28))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, editForm.value.site_id]
                        ])
                      ])
                    ]),
                    (siteLoadMessage.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(siteLoadMessage.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editForm.value.equipment_type_id) = $event)),
                          type: "number",
                          min: "0"
                        }, null, 512), [
                          [
                            _vModelText,
                            editForm.value.equipment_type_id,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editForm.value.equipment_length) = $event)),
                          type: "number",
                          min: "0",
                          step: "0.01"
                        }, null, 512), [
                          [
                            _vModelText,
                            editForm.value.equipment_length,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editForm.value.equipment_width) = $event)),
                          type: "number",
                          min: "0",
                          step: "0.01"
                        }, null, 512), [
                          [
                            _vModelText,
                            editForm.value.equipment_width,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editForm.value.equipment_height) = $event)),
                          type: "number",
                          min: "0",
                          step: "0.01"
                        }, null, 512), [
                          [
                            _vModelText,
                            editForm.value.equipment_height,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editForm.value.equipment_measurement_unit) = $event)),
                          class: "form-select"
                        }, _hoisted_46, 512), [
                          [_vModelSelect, editForm.value.equipment_measurement_unit]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((editForm.value.slideouts) = $event)),
                          class: "form-select"
                        }, _hoisted_54, 512), [
                          [_vModelSelect, editForm.value.slideouts]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("div", _hoisted_57, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editForm.value.status) = $event)),
                        class: "form-select"
                      }, _hoisted_67, 512), [
                        [_vModelSelect, editForm.value.status]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("button", {
                      class: "btn btn-blue",
                      type: "submit",
                      disabled: savingBooking.value
                    }, _toDisplayString(savingBooking.value ? "Saving..." : "Update Booking"), 9, _hoisted_69),
                    _createElementVNode("button", {
                      class: "btn",
                      type: "button",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (editingBooking.value = false))
                    }, " Cancel ")
                  ])
                ], 40, _hoisted_6))
              : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _hoisted_72,
                    (primaryGuestId(booking.value))
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 0,
                          to: {
              name: 'nb_guest_detail',
              params: {
                guestId: primaryGuestId(booking.value),
                facilityId: __props.facilityId,
                facilityName: __props.facilityName,
              },
            }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(primaryGuestName(booking.value)), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_73, "-"))
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("span", null, _toDisplayString(formatDate(booking.value.booking_arrival)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _hoisted_77,
                    _createElementVNode("span", null, _toDisplayString(formatDate(booking.value.booking_departure)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("span", null, _toDisplayString(booking.value.booking_status || "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _hoisted_81,
                    _createElementVNode("span", null, _toDisplayString(money(bookingTotal(booking.value))), 1)
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createElementVNode("span", null, _toDisplayString(_unref(nightlyRate) !== null ? money(_unref(nightlyRate)) : "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _hoisted_85,
                    _createElementVNode("span", null, _toDisplayString(money(bookingBalance(booking.value))), 1)
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _createElementVNode("span", null, _toDisplayString(booking.value.booking_adults ?? "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _createElementVNode("span", null, _toDisplayString(booking.value.booking_children ?? "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _hoisted_91,
                    _createElementVNode("span", null, _toDisplayString(booking.value.booking_animals ?? "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _hoisted_93,
                    _createElementVNode("span", null, _toDisplayString(siteLabel(booking.value) || "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _hoisted_95,
                    _createElementVNode("span", null, _toDisplayString(categoryLabel(booking.value) || "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _hoisted_97,
                    _createElementVNode("span", null, _toDisplayString(equipmentLabel(booking.value) || "-"), 1)
                  ])
                ])),
            (!editingBooking.value && _unref(tariffsQuoted).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                  _hoisted_99,
                  _createElementVNode("table", _hoisted_100, [
                    _hoisted_101,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tariffsQuoted), (row, idx) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: String(row.tariff_quoted_id || idx)
                      }, [
                        _createElementVNode("td", null, _toDisplayString(row.stay_date || "-"), 1),
                        _createElementVNode("td", null, _toDisplayString(money(
                  row.charge_amount ??
                    row.calculated_amount ??
                    row.original_amount
                )), 1),
                        _createElementVNode("td", null, _toDisplayString(tariffPlanLabel(row, booking.value)), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!editingBooking.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                  _hoisted_103,
                  (payments.value.length)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_104, [
                        _hoisted_105,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payments.value, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: String(item.id || idx)
                          }, [
                            _createElementVNode("td", null, _toDisplayString(formatDate(item.generated_when)), 1),
                            _createElementVNode("td", null, _toDisplayString(item.description || "Payment"), 1),
                            _createElementVNode("td", null, _toDisplayString(item.type || item.transaction_method || "-"), 1),
                            _createElementVNode("td", null, [
                              _createTextVNode(_toDisplayString(money(item.amount)) + " ", 1),
                              (item.voided_when)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_106, "(voided)"))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_107, "No payments recorded for this booking yet.")),
                  _createElementVNode("p", _hoisted_108, [
                    _hoisted_109,
                    _createElementVNode("strong", null, _toDisplayString(money(_unref(paymentsTotal))), 1),
                    _hoisted_110,
                    _createElementVNode("strong", null, _toDisplayString(money(bookingBalance(booking.value))), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!editingBooking.value && booking.value.account_breakdown?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                  _hoisted_112,
                  _createElementVNode("table", _hoisted_113, [
                    _hoisted_114,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.account_breakdown, (item, idx) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: String(item.gl_category_id || item.name || idx)
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.name || "Account"), 1),
                        _createElementVNode("td", null, _toDisplayString(money(item.balance)), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!editingBooking.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                  _hoisted_116,
                  _createElementVNode("form", {
                    class: "note-form",
                    onSubmit: _withModifiers(saveBookingNote, ["prevent"])
                  }, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((bookingNote).value = $event)),
                      rows: "4",
                      placeholder: "Add a note about changes made to this booking"
                    }, null, 512), [
                      [_vModelText, bookingNote.value]
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("button", {
                        class: "btn btn-blue",
                        type: "submit",
                        disabled: savingBookingNote.value || !bookingNote.value.trim()
                      }, _toDisplayString(savingBookingNote.value ? "Saving..." : "Save Note"), 9, _hoisted_119)
                    ])
                  ], 40, _hoisted_117),
                  (_unref(bookingNotes).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookingNotes), (note, index) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: String(note.id || note.note_id || index),
                            class: "note-item"
                          }, [
                            _createElementVNode("div", _hoisted_121, [
                              _createElementVNode("strong", null, _toDisplayString(noteTitle(note)), 1),
                              _createElementVNode("span", null, _toDisplayString(noteDate(note)), 1)
                            ]),
                            _createElementVNode("p", null, _toDisplayString(noteContent(note)), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_122, "No notes found for this booking."))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (showPaymentLink.value)
        ? (_openBlock(), _createBlock(NewbookPaymentLinkModal, {
            key: 4,
            "booking-id": __props.bookingId,
            "facility-id": __props.facilityId,
            onModalClosed: _cache[17] || (_cache[17] = ($event: any) => (showPaymentLink.value = false))
          }, null, 8, ["booking-id", "facility-id"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})